import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import tw from 'twin.macro'
import { useDispatch, useSelector } from 'react-redux'
import { FetchMCsCounts } from 'src/constants/actionTypes'
import { getSelectedMarket } from 'src/selectors/market'
import { Typography } from '@mui/material'
import { ManageTagsButton } from 'src/components/tags/ManageTagsButton'
import { MCTabs } from '../tabs/MCTabs'
import { useLocation } from 'react-router-dom'
import { MCsTable } from '../mcs-table/MCsTable'
import { MCsContext, IMCsContext } from './MCs.context'
import { MCStatus } from 'src/constants/mc/enums'

const MCsComponent = () => {
  const dispatch = useDispatch()
  const { state } = useLocation()

  const selectedMarket = useSelector(getSelectedMarket)

  const selectedTabRef = useRef<MCStatus | null>(null)

  const [selectedTab, setSelectedTab] = useState(MCStatus.Activated)
  const [searchQuery, setSearchQuery] = useState<string>('')

  const handleChangeTab = useCallback((tab: MCStatus) => {
    selectedTabRef.current = tab
    setSelectedTab(tab)
  }, [])

  useEffect(() => {
    if (!state?.selectedTab || state?.selectedTab === selectedTabRef.current) {
      return
    }

    handleChangeTab(state?.selectedTab)
  }, [state?.selectedTab])

  const fetchMCsCounts = useCallback(() => {
    const params: any = {}

    if (selectedMarket?.id) {
      params.partnerMarketId = selectedMarket?.id
    }

    dispatch(FetchMCsCounts.request(params))
  }, [selectedMarket?.id])

  useEffect(() => {
    fetchMCsCounts()
  }, [fetchMCsCounts])

  const contractorsContextValue = useMemo<IMCsContext>(() => {
    return {
      searchQuery,
      setSearchQuery,
    }
  }, [searchQuery, setSearchQuery])

  return (
    <MCsContext.Provider value={contractorsContextValue}>
      <div>
        <div css={tw`flex flex-row items-center justify-between mb-6 gap-4`}>
          <Typography variant="h2" css={tw`mb-2`}>
            Master Contractors List
          </Typography>
          <div>
            <ManageTagsButton />
          </div>
        </div>
        <MCTabs selectedTab={selectedTab} onClick={handleChangeTab} />
        {selectedTab === MCStatus.Activated && <MCsTable selectedStatus={MCStatus.Activated} />}
        {selectedTab === MCStatus.Deactivated && <MCsTable selectedStatus={MCStatus.Deactivated} />}
      </div>
    </MCsContext.Provider>
  )
}

export const MCs = memo(MCsComponent)
